// extracted by LIB_CSS_EXTRACT_LOADER
import "./alert_module.css"
export default {"alert":"alert-DgrFrc","default":"default-CmG8G5","description":"description-TazenT","destructive":"destructive-MREskk","title":"title-dbqf11"};